exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classes---wrapper---2jK7K {\n  max-width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 4rem;\n  background-color: white;\n  padding: 2rem;\n  border: 1px solid #e6e6e6; }\n", ""]);

// exports
exports.locals = {
	"wrapper": "classes---wrapper---2jK7K"
};